// extracted by mini-css-extract-plugin
module.exports = {"verifyToken":"VerifyToken_verifyToken__5Y97q"};